import { render, staticRenderFns } from "./personnelOverview_listActivities.vue?vue&type=template&id=195872b0&scoped=true&"
import script from "./personnelOverview_listActivities.vue?vue&type=script&lang=js&"
export * from "./personnelOverview_listActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195872b0",
  null
  
)

export default component.exports